import React, { FC } from 'react';
import styles from './styles.module.css';
import { CoverageInput } from './CoverageInput';
import { CoverageFormOptionType } from './types';

type PolicyLevelCoveragesProps = {
  coverages: Array<CoverageFormOptionType>;
  endorsements: Array<CoverageFormOptionType>;
  disabled?: boolean;
  hasParentCoverage?: boolean;
};

export const PolicyLevelCoverages: FC<PolicyLevelCoveragesProps> = ({
  coverages,
  endorsements,
  disabled = false,
  hasParentCoverage = false,
}) => {
  return (
    <div className={styles.policyCoveragesContainer}>
      <h1>Policy Level</h1>
      {coverages.map(coverage => {
        let stackedEndorsements = hasParentCoverage
          ? endorsements.filter(
              endorsement => endorsement.parentCoverage === coverage.identifier
            )
          : [];

        if (stackedEndorsements.length > 0) {
          stackedEndorsements = stackedEndorsements.map(endorsement => {
            const updatedCoverageOptions = Object.keys(
              endorsement.coverageOptions
            ).reduce((acc, key) => {
              acc[key] =
                endorsement.parentCoverageOptionsSynonyms?.find(
                  (option: any) => option.value === key
                )?.label || endorsement.coverageOptions[key];
              return acc;
            }, {} as any);

            return {
              ...endorsement,
              coverageOptions: updatedCoverageOptions,
            };
          });
        }

        return (
          <CoverageInput
            key={coverage.identifier}
            type="coverage"
            coverage={coverage}
            formKey={`policyCoverages.coverages.${coverage.identifier}`}
            disabled={disabled}
            stackedEndorsements={stackedEndorsements}
          />
        );
      })}
      {endorsements
        .filter(endorsement => !endorsement.parentCoverage)
        .map(coverage => (
          <CoverageInput
            key={coverage.identifier}
            type="endorsement"
            coverage={coverage}
            formKey={`policyCoverages.endorsements.${coverage.identifier}`}
            disabled={disabled}
          />
        ))}
    </div>
  );
};

PolicyLevelCoverages.displayName = 'PolicyLevelCoverages';
